import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import category from 'src/types/category';
import 'src/components/DesktopTabs.scss';


const DesktopTabs = ({ categories, activateTab }) => {
  const activateTabMemo = useCallback(activateTab, [activateTab]);

  return (
    <ul>
      {
      categories.map(({ id, name, active }) => {
        const dataTest = `button-${name}`;
        return (
          <li key={ id } styleName={ classNames({ category: true, 'category--active': active }) }>
            <button
              data-test={ dataTest }
              onClick={ () => activateTabMemo(id) }
              styleName="category__button"
              type="button"
            >
              {name}
            </button>
          </li>
        );
      })
    }
    </ul>
  );
};


DesktopTabs.propTypes = {
  activateTab: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(category)).isRequired
};


export default DesktopTabs;
